<div>
  <div>
    <span class="pageHeader" id="monthlyReportsHeader">

									Monthly Reports
								</span>

  </div>
  <br>

  <div>
    <div class="repTblAlign">
      <table>
        <tr>
          <td><B>Premium Pricing Reports</B></td>
        </tr>
        <tr>
          <td><a role="button" (click)="onMonthlyReportClick('RPT_100','Premium Pricing Loan Report')"> Loan Report</a></td>
        </tr>
        <tr>
          <td><a role="button" (click)="onMonthlyReportClick('RPT_104','104-Monthly Premium Pay Off Summary Report')">Payoff Summary Report</a></td>
        </tr>
        <tr>
          <td><a role="button" (click)="onMonthlyReportClick('RPT_102','102-Monthly Premium Pay Off Details Report')">Payoff Details Report</a></td>
        </tr>
        <tr>
          <td><a role="button" (click)="onMonthlyReportClick('RPT_103','103-Premium Pricing GL Reconciliation Report')">GL Reconciliation Report</a></td>
        </tr>
        <br>

      </table>
    </div>
  </div>
</div>
<br>
